export default __webpack_public_path__ + "static/media/480_dummy2016-immobilien01-de.b7b45d6c.png";